// Official Promptivo real-estate category + status icons (delivered assets).
// SVGs use stroke="currentColor" so color follows text color (accent when active).
import { ReactComponent as Interiors } from "@/assets/category-icons/zdjecia-wnetrz.svg";
import { ReactComponent as Facade } from "@/assets/category-icons/zdjecia-elewacji.svg";
import { ReactComponent as HomeStaging } from "@/assets/category-icons/home-staging.svg";
import { ReactComponent as Listing } from "@/assets/category-icons/ogloszenia.svg";
import { ReactComponent as Ads } from "@/assets/category-icons/reklamy-i-posty.svg";
import { ReactComponent as Reels } from "@/assets/category-icons/rolki-i-filmy.svg";
import { ReactComponent as Developers } from "@/assets/category-icons/dla-deweloperow.svg";
import { ReactComponent as Agent } from "@/assets/category-icons/marka-agenta.svg";

import { ReactComponent as ActivePackage } from "@/assets/status-icons/pakiet-aktywny.svg";
import { ReactComponent as Updates } from "@/assets/status-icons/aktualizacje.svg";
import { ReactComponent as LastUpdate } from "@/assets/status-icons/data-aktualizacji.svg";

const wrap = (Comp) =>
  function Icon({ size = 28, className }) {
    return <Comp width={size} height={size} className={className} aria-hidden="true" />;
  };

export const CATEGORY_ICON_MAP = {
  "zdjecia-wnetrz": wrap(Interiors),
  "zdjecia-elewacji": wrap(Facade),
  "home-staging": wrap(HomeStaging),
  "ogloszenia": wrap(Listing),
  "reklamy-i-posty": wrap(Ads),
  "rolki-i-filmy": wrap(Reels),
  "dla-deweloperow": wrap(Developers),
  "marka-agenta": wrap(Agent),
};

export const STATUS_ICONS = {
  active: wrap(ActivePackage),
  updates: wrap(Updates),
  lastUpdate: wrap(LastUpdate),
};
